import { useEffect, useState } from 'react';




const useQualtrics = (showQTXSurvey) => {
    const [loadQTX, setLoadQTX] = useState(false);
    useEffect(() => {
        if (showQTXSurvey && !loadQTX) {
            QSI.API.unload();
            QSI.API.load();
            QSI.API.run();
            setLoadQTX(true);
            return () => { console.info(`useQualtrics clean up.`); };
        } else {
            return () => { console.info(`useQualtrics did not reload loadQTX:${loadQTX} showQTXSurvey:${showQTXSurvey}`);}
        }
    });
};
export default useQualtrics;